import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-view-document',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
  template: `
  <div class="view-document-button" *ngIf="canView">
    <button mat-icon-button (click)="onClick()">
      <mat-icon>visibility</mat-icon>
    </button>
  </div>
  `
})
export class ViewDocumentComponent {

  canView = false;
  _data: any;

  @Input() set data(data: any) {
    this._data = data;
    this.canView = !!this._data?.canview;
  }

  @Output() action = new EventEmitter();

  onClick() {
    this.action.emit(this._data);
  }
}
